module.exports = __webpack_public_path__ + "static/media/thunder_cracking.afcdbf72.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/thunder_cracking.wav
// module id = 31
// module chunks = 0